import * as types from './ActionTypes';
import UrlParser from 'utils/parsers/UrlParser';
import { gcApi } from 'config/axios';

/**
 * CALENDAR PAGE
 */
export const requestCalendarPreferences = () => ({
    type: types.REQUEST_CALENDAR_PREFERENCES
});

export const receiveCalendarPreferences = (json) => ({
    type: types.RECEIVE_CALENDAR_PREFERENCES,
    calendarPreferences: json
});

export const updateCalendarPreferences = (prefs) => ({
    type: types.UPDATE_CALENDAR_PREFERENCES,
    calendarPreferences: prefs
});

export const setModalDispatcher = (type, data, date, trainingPlanId) => {
    return {
        type: types.SET_MODAL_DISPATCHER,
        modal: type,
        data,
        date,
        trainingPlanId
    };
};

export const resetModalDispatcher = () => {
    return { type: types.RESET_MODAL_DISPATCHER };
};

export const showAddMenu = (date, clickTop, clickLeft) => {
    return {
        type: types.SHOW_ADD_MENU,
        date,
        clickTop,
        clickLeft
    };
};

export const hideAddMenu = () => {
    return {
        type: types.HIDE_ADD_MENU
    };
};

export const setCalendarYearMonthDate = (year, month, date) => ({
    type: types.SET_CALENDAR_YEAR_AND_MONTH,
    year,
    month,
    date
});

export const requestCalendarWeek = (year, month, day, firstDayOfWeek, groupId, append = false) => ({
    type: types.REQUEST_CALENDAR_WEEK,
    year,
    month,
    day,
    firstDayOfWeek,
    groupId,
    append
});

export const receiveCalendarWeek = (json, append) => ({
    type: types.RECEIVE_CALENDAR_WEEK,
    calendarWeek: json,
    receivedAt: Date.now(),
    append
});

export const requestCalendarMonth = (year, month, groupId, append = false) => ({
    type: types.REQUEST_CALENDAR_MONTH,
    year,
    month,
    groupId,
    append
});

export const receiveCalendarMonth = (json, append) => ({
    type: types.RECEIVE_CALENDAR_MONTH,
    calendarMonth: json,
    receivedAt: Date.now(),
    append
});

export const updateCalendarItems = (items, view) => ({
    type: types.UPDATE_CALENDAR_ITEMS,
    items,
    view
});

export const setCalendarSnackbar = (message) => ({
    type: types.SET_CALENDAR_SNACKBAR,
    message
});

export const showAddSidebar = (content, date, editMode, data) => ({
    type: types.SHOW_ADD_SIDEBAR,
    content,
    date,
    editMode,
    data
});

export const hideAddSidebar = () => ({
    type: types.HIDE_ADD_SIDEBAR
});

export const addNote = (url, title, note, date) => {
    return gcApi.post(`/calendar-service/note`, {
        noteName: title,
        content: note,
        date,
        id: null
    });
};

export const updateNote = (url, noteId, title, note, date) => {
    return gcApi.put(`/calendar-service/note/${noteId}`, {
        noteName: title,
        content: note,
        date,
        id: noteId
    });
};

export const updateTrainingPlanNote = (url, noteId, title, note, date, trainingPlanId, ownerId) => {
    return gcApi.put(`/trainingplan-service/trainingplan/scheduled/notes/${noteId}`, {
        noteName: title,
        content: note,
        date,
        trainingPlanId,
        id: noteId,
        ownerId
    });
};

export const requestCalendarNote = (noteId) => ({
    type: types.REQUEST_CALENDAR_NOTE,
    noteId
});

export const receiveCalendarNote = (json, noteId) => ({
    type: types.RECEIVE_CALENDAR_NOTE,
    noteId,
    json
});

export const requestTrainingPlanCalendarNote = (noteId) => ({
    type: types.FETCH_TRAINING_PLAN_CALENDAR_NOTE,
    noteId
});

export const deleteNote = (url, noteId) => {
    return gcApi.delete(`/calendar-service/note/${noteId}`);
};

export const deleteTrainingPlanNote = (noteId, tpId) => {
    return gcApi.delete(`/trainingplan-service/trainingplan/noteTask/${tpId}/${noteId}`);
};

export const updateCalendarItemDate = (type, item, newDate) => {
    return gcApi.put(`/calendar-service/calendarItem/${type}/${item.id}/date/${newDate}`, {
        ...item,
        date: newDate
    });
};

export const requestTrainingPlansForDate = (date) => ({
    type: types.REQUEST_TRAINING_PLANS_FOR_DATE,
    date
});

export const receiveTrainingPlansForDate = (json, date) => ({
    type: types.RECEIVE_TRAINING_PLANS_FOR_DATE,
    date,
    tps: json ? json.trainingPlanList : [],
    receivedAt: Date.now()
});

export const fetchTrainingPlansForDatePromise = (date) => {
    return gcApi.get(`/trainingplan-service/trainingplan/active-plans?startDate=${date}`);
};

export const fetchTrainingPlan = (tpId, callback) => ({
    type: types.FETCH_TRAINING_PLAN,
    tpId,
    callback
});

export const requestTrainingPlan = () => ({
    type: types.REQUEST_TRAINING_PLAN
});

export const receiveTrainingPlan = (json) => ({
    type: types.RECEIVE_TRAINING_PLAN,
    tp: json,
    receivedAt: Date.now()
});

export const scheduleTrainingPlan = (tpId, date) => {
    return gcApi.get(`/trainingplan-service/trainingplan/schedule/${tpId}?&startDate=${date}`);
};

export const addWorkoutToTrainingPlan = (tpId, workoutScheduleId, date) => {
    return gcApi.post(
        `/trainingplan-service/trainingplan/addWorkoutTask/${tpId}`,
        `workoutSchedulePk=${workoutScheduleId}&scheduleDate=${date}`,
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        }
    );
};

export const removeWorkoutFromTrainingPlan = (tpId, workoutScheduleId) => {
    return gcApi.delete(`/trainingplan-service/trainingplan/workoutTask/${tpId}/${workoutScheduleId}`);
};

export const updateTrainingPlanNoteDate = (noteId, tpId, date) => {
    return gcApi.post(
        `/trainingplan-service/trainingplan/moveNoteTask/${tpId}`,
        `noteSchedulePk=${noteId}&scheduleDate=${date}`,
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        }
    );
};

export const updateTrainingPlanWorkoutDate = (workoutId, tpId, date) => {
    return gcApi.post(
        `/trainingplan-service/trainingplan/moveWorkoutTask/${tpId}`,
        `workoutSchedulePk=${workoutId}&scheduleDate=${date}`,
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        }
    );
};

export const addEvent = (data, groupId, image, onSuccess = () => {}, isOfficial, isCoachFlow = false) => {
    let url = `/calendar-service/event${isCoachFlow ? '?eventCreatorFlow=GARMIN_COACH' : ''}`;
    if (groupId) {
        url = `/calendar-service/group/${groupId}/event`;
    }
    return gcApi
        .post(url, data)
        .then((response) => {
            // POST image if one exists using the new event id
            if (image && response.data.id) {
                const formData = new FormData();
                formData.append('file', image);
                let imgUrl = `/calendar-service/event/${response.data.id}/image`;
                gcApi.post(imgUrl, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
            }
            onSuccess(response.data);
            if (isOfficial) {
                gcApi.put(`/calendar-service/event/${response.data.id}/status/PENDING_OFFICIAL`);
            }
            return response;
        })
        .catch((error) => {
            return error;
        });
};

export const updateEventStatus = (event) => {
    if (!event.official && event.statuses?.includes('OFFICIAL')) {
        return gcApi.delete(`/calendar-service/event/${event.id}/status/OFFICIAL`);
    } else if (event.official && !event.statuses?.includes('OFFICIAL')) {
        return gcApi.put(`/calendar-service/event/${event.id}/status/PENDING_OFFICIAL`);
    }
};

export const updateEvent = (NavUrl, eventId, data, groupId) => {
    let url = `/calendar-service/`;
    if (groupId) {
        url += `group/${groupId}/`;
    }

    url += `event/${eventId}`;

    if (data.eventGoal) {
        delete data.eventGoal;
    }

    return gcApi.put(url, data).then(() => {
        if (!data.official && data.statuses?.includes('OFFICIAL')) {
            gcApi.delete(`/calendar-service/event/${eventId}/status/OFFICIAL`);
        } else if (data.offical && !data.statuses?.includes('OFFICIAL')) {
            gcApi.put(`/calendar-service/event/${eventId}/status/PENDING_OFFICIAL`);
        }
    });
};

export const batchUpdateEvents = (events, successHandler = () => {}, errorHandler = () => {}) => {
    let puts = events.map((event) => {
        return gcApi.put(`/calendar-service/event/${event.id}`, event);
    });
    Promise.all(puts)
        .then(() => {
            successHandler();
        })
        .catch((errors) => {
            errorHandler(errors);
        });
};

export const deleteEvent = (url, eventId, groupId) => {
    let deleteUrl = `/calendar-service/`;
    if (groupId) {
        deleteUrl += `group/${groupId}/`;
    }
    deleteUrl += `event/${eventId}`;

    return gcApi.delete(deleteUrl);
};

export const subscribeToEvent = (shareableEventUuid) => {
    const url = `/calendar-service/event/${shareableEventUuid}/subscription`;
    return gcApi.post(url);
};

export const removeEventFromCalendar = (shareableEventUuid) => {
    const url = `/calendar-service/event/${shareableEventUuid}/subscription`;
    return gcApi.delete(url);
};

export const updateEventImage = (eventId, image) => {
    const url = `/calendar-service/event/${eventId}/image`;

    return gcApi.delete(url).then(() => {
        const formData = new FormData();
        formData.append('file', image);
        let imgUrl = `/calendar-service/event/${eventId}/image`;
        gcApi.post(imgUrl, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    });
};

export const deleteEventImage = (eventId) => {
    const url = `/calendar-service/event/${eventId}/image`;
    return gcApi.delete(url);
};

export const getEventImage = (eventId, imageuuid) => {
    return gcApi.get(`/calendar-service/event/${eventId}/image/${imageuuid}`);
};

export const createEventFromDiscoverableEvent = (discoverableEvent) => {
    const config = {
        headers: {
            'X-RaceEvent-Sig': discoverableEvent.sig
        }
    };
    const url = '/calendar-service/event/discoverable/conversion';
    return gcApi.put(url, discoverableEvent, config);
};

export const requestCalendarEvent = () => ({
    type: types.REQUEST_CALENDAR_EVENT
});

export const receiveCalendarEvent = (json, eventId) => ({
    type: types.RECEIVE_CALENDAR_EVENT,
    eventId,
    json
});

export const fetchCalendarEvent = (eventId, groupId, shareable, callback) => ({
    type: types.FETCH_CALENDAR_EVENT,
    eventId,
    groupId,
    shareable,
    callback
});

export const fetchEvent = (eventId, groupId, shareable) => {
    let url = '/calendar-service/';
    if (groupId) {
        url += `group/${groupId}/`;
    }
    url += `event/${eventId}`;
    if (shareable) {
        url += `/shareable`;
    }
    return gcApi.get(url);
};

export const fetchActivePlans = () => {
    return gcApi.get('/atp/athlete/active');
};

export const fetchCalendarEvents = (params) => {
    const query = new UrlParser().convertObjectToQueryString(params);
    return gcApi.get(`/calendar-service/events${query}`);
};

export const requestCalendarExport = (callback) => ({
    type: types.REQUEST_CALENDAR_EXPORT,
    callback
});

export const receiveCalendarExport = (json) => ({
    type: types.RECEIVE_CALENDAR_EXPORT,
    json
});

export const publishCalendarExport = (data, callback) => ({
    type: types.PUBLISH_CALENDAR_EXPORT,
    data,
    callback
});

export const unPublishCalendarExport = (id, callback) => ({
    type: types.UNPUBLISH_CALENDAR_EXPORT,
    id,
    callback
});

export const requestCalendarYear = (year, groupId) => ({
    type: types.REQUEST_CALENDAR_YEAR,
    year,
    groupId
});

export const receiveCalendarYear = (json) => ({
    type: types.RECEIVE_CALENDAR_YEAR,
    calendarYear: json,
    receivedAt: Date.now()
});

export const resetCalendarPage = () => ({
    type: types.RESET_CALENDAR_PAGE
});

export const displayCalendarMessage = (display) => ({
    type: types.DISPLAY_CALENDAR_MESSAGE,
    show: display
});

export const calendarItemsSentToDevice = () => ({
    type: types.SEND_CALENDAR_ITEMS_TO_DEVICE_SUCCESS
});

export const calendarItemsSentToDeviceError = () => ({
    type: types.SEND_CALENDAR_ITEMS_TO_DEVICE_ERROR
});

export const resetItemsSentToDevice = () => ({
    type: types.RESET_CALENDAR_ITMES_TO_DEVICE
});

export const sendCalendarItemsToDevice = () => ({
    type: types.SEND_CALENDAR_ITEMS_TO_DEVICE
});

export const refreshCalendar = (date) => ({
    type: types.REFRESH_CALENDAR,
    date
});

export const fetchTimezones = (evictCache) => {
    return {
        type: types.FETCH_TIMEZONES,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
};

export const fetchSubscriberEventDetailsWithCallback = (shareableEventUuid, callback) => {
    return {
        type: types.FETCH_SUBSCRIBER_EVENT_DETAILS,
        shareableEventUuid,
        callback
    };
};

export const fetchSubscriberEventDetails = (shareableEventUuid, evictCache) => {
    return {
        type: types.FETCH_SUBSCRIBER_EVENT_DETAILS,
        shareableEventUuid,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
};

export const resetSubscriberEventDetails = () => {
    return {
        type: types.RESET_SUBSCRIBER_EVENT_DETAILS
    };
};

export const reportEventImage = ({ eventImageUUID, reason, note, shareableEventUuid }) => {
    const payload = {
        eventImageUUID,
        reason,
        note
    };
    const url = `/calendar-service/event/${shareableEventUuid}/flag-image`;
    return gcApi.put(url, payload);
};

export const requestPrimaryEventMetadata = (evictCache) => ({
    type: types.REQUEST_PRIMARY_EVENT_METADATA,
    meta: {
        cacheTime: evictCache ? null : 10000
    }
});

export const receivePrimaryEventMetadata = (json) => ({
    type: types.RECEIVE_PRIMARY_EVENT_METADATA,
    json
});

export const receiveUpcomingEvents = (json) => ({
    type: types.RECEIVE_CALENDAR_UPCOMING_EVENTS,
    data: json,
    receivedAt: Date.now()
});

export const requestUpcomingEvents = ({ numDaysForward, limit, callback }) => ({
    type: types.REQUEST_CALENDAR_UPCOMING_EVENTS,
    numDaysForward,
    limit,
    callback
});

export const fetchUpcomingEventsPromise = ({ numDaysForward, limit }) => {
    let url = `/calendar-service/events/upcoming?numDaysForward=${numDaysForward}&limit=${limit}`;
    return gcApi.get(url);
};

export const updateEventCustomization = (shareableEventUuid, eventCustomization) => {
    let url = `/calendar-service/event/${shareableEventUuid}/customization`;

    return gcApi.put(url, eventCustomization);
};

export const batchUpdateEventCustomizations = (events, successHandler = () => {}, errorHandler = () => {}) => {
    let puts = events.map((event) => {
        return gcApi.put(`/calendar-service/event/${event.shareableEventUuid}/customization`, event.eventCustomization);
    });
    Promise.all(puts)
        .then(() => {
            successHandler();
        })
        .catch((errors) => {
            errorHandler(errors);
        });
};

export const fetchEventForCoachPlan = (trainingPlanId) => {
    let url = `/calendar-service/events?trainingPlanId=${trainingPlanId}`;
    return gcApi.get(url);
};

export const fetchEventsByDate = ({ startDate, endDate, eventType, pageIndex, limit, sort, callback }, evictCache) => {
    return {
        type: types.FETCH_EVENTS_BY_DATE,
        startDate,
        endDate,
        eventType,
        pageIndex,
        limit,
        sort,
        callback,
        meta: {
            cacheTime: evictCache ? null : 10000
        }
    };
};

export const resetEventsByDate = () => {
    return {
        type: types.RESET_FETCH_EVENTS_BY_DATE
    };
};

export const addEventToDuplicate = (event) => {
    return {
        type: types.ADD_EVENT_TO_DUPLICATE,
        event
    };
};

export const removeEventToDuplicate = () => {
    return {
        type: types.REMOVE_EVENT_TO_DUPLICATE
    };
};

export const addEventToEdit = ({ tab, date, id, shareableEventUuid, pageIndex, sortColumn, sortOrder }) => {
    return {
        type: types.ADD_EVENT_TO_EDIT,
        tab,
        date,
        id,
        shareableEventUuid,
        pageIndex,
        sortColumn,
        sortOrder
    };
};

export const removeEventToEdit = () => {
    return {
        type: types.REMOVE_EVENT_TO_EDIT
    };
};

export const requestUpcomingEventsForCourseId = (courseId) => ({
    type: types.REQUEST_CALENDAR_UPCOMING_EVENTS_FOR_COURSE_ID,
    courseId: courseId
});

export const fetchRaceEventProviders = (evictCache) => {
    return {
        type: types.FETCH_RACE_EVENT_PROVIDERS,
        meta: {
            cacheTime: evictCache ? null : 3600000
        }
    };
};

export const addTemporaryEvent = (event) => {
    return {
        type: types.ADD_TEMPORARY_EVENT,
        event
    };
};

export const removeTemporaryEvent = () => {
    return {
        type: types.REMOVE_TEMPORARY_EVENT
    };
};
